import React from 'react';
import {useTouchDevice} from '@pexip/components';
import {TouchDeviceContext} from './TouchDevice.context';

export const TouchDeviceProvider: React.FC<React.PropsWithChildren> = ({
    children,
}) => {
    const isTouchDevice = useTouchDevice();
    return (
        <TouchDeviceContext.Provider value={isTouchDevice}>
            {children}
        </TouchDeviceContext.Provider>
    );
};
